interface ButtonItem {
  label: string;
  url: string;
  variant?: 'primary' | 'secondary' | 'outline';
}

interface ButtonGroupProps {
  buttons?: ButtonItem[];
  alignment?: 'left' | 'center' | 'right';
  gap?: 'sm' | 'md' | 'lg';
}

const GAP_MAP: Record<string, string> = { sm: 'gap-2', md: 'gap-3', lg: 'gap-4' };

const VARIANT_STYLES: Record<string, string> = {
  primary: 'bg-indigo-600 text-white hover:bg-indigo-700',
  secondary: 'bg-zinc-200 text-zinc-800 hover:bg-zinc-300',
  outline: 'border border-zinc-300 text-zinc-700 hover:bg-zinc-50',
};

export function ButtonGroupBlock({ props }: { props: ButtonGroupProps }) {
  const buttons = props.buttons ?? [];
  if (buttons.length === 0) return null;
  const align = props.alignment === 'right' ? 'justify-end' : props.alignment === 'left' ? 'justify-start' : 'justify-center';
  const gap = GAP_MAP[props.gap ?? 'md'] ?? 'gap-3';

  return (
    <div className={`flex flex-wrap ${align} ${gap} py-4`}>
      {buttons.map((btn, i) => (
        <a
          key={i}
          href={btn.url}
          className={`px-5 py-2.5 rounded-lg text-sm font-medium transition-colors ${VARIANT_STYLES[btn.variant ?? 'primary'] ?? VARIANT_STYLES.primary}`}
        >
          {btn.label}
        </a>
      ))}
    </div>
  );
}
